import { heroImage, siteInfo, stats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative h-[520px] w-full overflow-hidden md:h-[640px]">
        <img
          src={heroImage}
          alt="黑料短剧雨夜场景剧照"
          title="黑料短剧 剧情解析"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>

        <div className="absolute inset-0">
          <div className="mx-auto flex h-full w-full flex-col justify-center px-4 md:px-6">
            <div className="w-full max-w-2xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3 py-1.5 text-xs font-medium text-background-100">
                <i className="ri-film-line"></i>
                都市悬疑短剧 · 剧情档案馆
              </span>
              <h1 className="mt-5 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
                {siteInfo.title}
              </h1>
              <p className="mt-3 font-heading text-lg text-primary-200 md:text-2xl">{siteInfo.tagline}</p>
              <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
                分集介绍、故事梗概、角色介绍与人物关系线一次看全，剧情解析同步更新，帮你在每一次反转里对上前面的伏笔。
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#episodes"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-play-list-2-line text-lg"></i>
                  查看分集介绍
                </a>
                <a
                  href="#analysis"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/15 cursor-pointer"
                >
                  <i className="ri-lightbulb-line text-lg"></i>
                  阅读剧情解析
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto -mt-12 w-full px-4 md:px-6">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="bg-background-50 px-5 py-6 text-center">
              <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                {item.value}
                <span className="ml-1 text-sm font-bold text-foreground-500">{item.unit}</span>
              </p>
              <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}